<div
  class="container d-flex fd-col jc-between ai-stretch"
  [ngClass]="{ 'viewing-organisations': viewingOrganisations }"
>
  <div class="top-sidenav flex-1 d-flex fd-col">
    <div class="logo-padding d-flex fd-col jc-start ai-stretch">
      <ng-container *ngIf="currentTenant() as ct">
        <logo
          *ngIf="ct.logoUrl"
          [logoUrl]="ct.logoUrl"
          [logoTheme]="'navy'"
          [route]="'private/overview'"
        ></logo>
        <div *ngIf="!ct.logoUrl" class="sitename-logo-alternative">{{ ct.tenantName }}</div>
      </ng-container>
      <!-- <div class="logo-tagline">ADMIN</div> -->
    </div>

    @if (loading && !viewingOrganisations) {
      <div class="links-sidenav flex-1 loading-state" aria-busy="true" aria-live="polite">
        <div class="loading-row" *ngFor="let _ of loadingRows; let i = index">
          <div class="loading-row-line"></div>
        </div>
      </div>
    } @else {
      <suvo-bi-list-navigation
        class="links-sidenav flex-1"
        [links]="viewingOrganisations ? organisationLinks : links"
        showIcons="true"
        [borderRadius]="'0 24px 24px 0'"
        [theme]="viewingOrganisations && 'inverted'"
        (onLinkClick)="handleLinkClick($event)"
        [showAskAQuestion]="mainNavLinksLoaded"
      ></suvo-bi-list-navigation>
    }
  </div>

  <!-- TODO: Handle responsive flex values with breakpoints -->
  <div class="d-flex fd-col">
    <mat-nav-list>
      <suvo-bi-account-sidenav-widget
        [showProfileLink]="true"
        [logoutRoute]="['/', 'identity']"
        *ngIf="!viewingOrganisations; else backToIrjPro"
        [loadOrganisation]="true"
      ></suvo-bi-account-sidenav-widget>

      <ng-template #backToIrjPro>
        <mat-divider></mat-divider>
        <a mat-list-item [routerLink]="['./', 'overview']">
          <mat-icon>arrow_back_ios</mat-icon>
          Back to IRJ Pro
        </a>
        <mat-divider></mat-divider>
      </ng-template>
    </mat-nav-list>
  </div>
</div>
